import { render, staticRenderFns } from "./PaywayError.vue?vue&type=template&id=90fd5974"
import script from "./PaywayError.vue?vue&type=script&lang=js"
export * from "./PaywayError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports